// extracted by css-extract-rspack-plugin
export default {"searchContainer":"DashboardSearch-module__searchContainer__xgU1Afy","actions":"DashboardSearch-module__actions__RBSqjBt"};